module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.code == undefined) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard margin-b20"
  }, [_c('li', {
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_c('div', {
    staticClass: "icon-step"
  }, [(_vm.isPJ) ? _c('i', {
    staticClass: "icon-globe"
  }) : _c('i', {
    staticClass: "icon-avatar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 2")]), _vm._v(" "), (_vm.isPJ) ? _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Dados da Empresa")]) : _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Seus dados")])])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 3, past: _vm.step > 3
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subtitle[_vm.step]))]), _vm._v(" "), (_vm.step == 0) ? [_c('choose-plan', {
    ref: "choosePlan",
    attrs: {
      "contract": _vm.contract
    }
  })] : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('company-data', {
    ref: "userData",
    attrs: {
      "account": _vm.account,
      "address": _vm.address
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('payment', {
    ref: "payment",
    staticClass: "margin-b20",
    attrs: {
      "payment": _vm.payment,
      "planId": _vm.planId,
      "addressMailing": _vm.address,
      "creditCardOptions": _vm.creditCardOptions,
      "tedOption": _vm.tedOption,
      "docOption": _vm.docOption,
      "bankAccountOptions": _vm.bankAccountOptions,
      "bankBillOption": _vm.bankBillOption
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('summary-comp', {
    ref: "summary",
    attrs: {
      "request": _vm.request,
      "newAdhesionTax": _vm.newAdhesionTax,
      "guaranteeTax": _vm.guaranteeTax,
      "newVehicleTax": _vm.newVehicleTax,
      "planName": _vm.planName,
      "showRecharge": _vm.showRecharge,
      "minValue": _vm.minValue
    },
    on: {
      "goToStep": _vm.goToStep
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('div', [(_vm.step != 0) ? _c('div', {
    staticClass: "back-button-box"
  }, [_c('button', {
    staticClass: "btn btn-back",
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n          Voltar\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  }), _vm._v("\n          Cancelar\n        ")]), _vm._v(" "), (_vm.step < 3 && !(_vm.isCaminhoParana && _vm.step == 0)) ? _c('button', {
    staticClass: "btn btn-purple add",
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n          Avançar\n          "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('button', {
    staticClass: "btn btn-success end",
    on: {
      "click": function($event) {
        return _vm.doRequest()
      }
    }
  }, [_vm._v("\n          Concluir\n          "), _c('i', {
    staticClass: "icon-tick align-icon-right-white"
  })]) : _vm._e()])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
    attrs: {
      "code": _vm.code,
      "boletoUrl": _vm.boletoUrl,
      "type": 'adhesion'
    }
  }), _vm._v(" "), _c('error-page', {
    attrs: {
      "code": _vm.code,
      "stepPayment": 3,
      "type": 'adhesion',
      "taxIdNumber": _vm.account.taxIdNumber,
      "password": _vm.account.accountAuthentication.password
    },
    on: {
      "goToStep": _vm.goToStep
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Adesão Move Mais")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-plans"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 1")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Plano e taxas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-payment-methods"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 3")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Forma de pagamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 4")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Resumo e confirmação")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-b6d8aed8!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/adhesion-shipper.vue
// module id = 2206
// module chunks = 1